// extracted by mini-css-extract-plugin
export default {"video-container":"HeroVideo_video-container__bAoIc"};